import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';

export default class PatrimonioMedidaTable extends Component {
  static propTypes = {
    medidas: PropTypes.object.isRequired
  };

  render() {
    const { medidas } = this.props;

    if (medidas.isEmpty()) return null;

    return (
      <Panel
        isTable
        tableResponsive
        expansible={false}
        title="Medidas do imóvel"
      >
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader empty={medidas.isEmpty()}>
              <tr>
                <th>Data</th>
                <th>Unidade de medida</th>
                <th>Medição</th>
                <th>Movimento</th>
              </tr>
            </TableHeader>
            <tbody>
              {medidas.map((medida, index) => (
                <tr key={index}>
                  <td>{DateUtils.formatDateTimeShort(medida.get('data'))}</td>
                  <td>{medida.get('unidadeMedida')}</td>
                  <td>
                    <NumberFormatter value={medida.get('medicao')} />
                  </td>
                  <td>{medida.get('movimento')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    );
  }
}
